module.exports = __webpack_public_path__ + "static/media/servicebanner1.5c9cd44e.jpg";